import * as FormActions from './Actions/FormActions.js'; 
import nchLogo from './nchLogo.png'; 
import NchLogoBlock from './Components/FieldTypes/NchLogoBlock.js';
import StatementBlock from './Components/FieldTypes/StatementBlock.js';
import DownloadButton from './Components/DownloadButton.js';

const ConfirmationMessage = (props) => {
  const originUrl = FormActions.GetOriginUrl(); //get the origin url for the form
    return (
        <div className="confirmation-message">
             <NchLogoBlock key = {"confirmation"} 
                className = "confirmation-logo"                    
                style={{ order: 1 }}
                logourl = {originUrl+ nchLogo}
                field = {{class:"", width: 12}}
            />

            <StatementBlock
                style={{ order: 2 }}
                field={{class: "confirmation-message-text", 
                    width: 12, 
                    objectkey : "confirmation-message-text",
                    fieldValue : props.message
                }}  
            />
            <DownloadButton {...props} />

           
        </div>
    );

}
export default ConfirmationMessage;